<template>
  <fn-list
    unstyled
    steps
  >
    <li
      v-for="(item, index) in data.items"
      :key="index"
    >
      <span>{{ index + 1 }}</span>
      <div v-html="item.content" />
    </li>
  </fn-list>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
